/**
 * One reminder bar for everything waiting for this person's answer (17 Oct
 * 2026), on every page but Approvals. It replaces the transfer approver's
 * bar and the enrolment approver's bar, and the leave half of the attendance
 * bar, which each pointed at a different page for part of the same queue.
 * Task checks keep their own bar and count on /tasks.
 */
import { Link, useLocation } from 'react-router-dom';
import { Inbox } from 'lucide-react';
import { APPROVAL_KINDS, APPROVAL_KIND_LABELS } from '@bright/shared';

import { formatNumber } from '@/lib/format';
import { useApprovalsSummary } from './approvals-api';

export function ApprovalsNudge() {
  const location = useLocation();
  const summary = useApprovalsSummary().data;
  if (!summary || summary.total === 0 || location.pathname === '/approvals') return null;
  const parts = APPROVAL_KINDS.filter((kind) => kind !== 'tasks' && (summary.waiting[kind] ?? 0) > 0).map(
    (kind) => `${APPROVAL_KIND_LABELS[kind].toLowerCase()} ${formatNumber(summary.waiting[kind] ?? 0)}`,
  );
  return (
    <Link
      to="/approvals"
      className="mb-3 flex items-center gap-3 rounded-md border border-line bg-surface-2 px-3 py-2 text-caption text-ink-2 hover:border-accent"
    >
      <Inbox className="h-4 w-4 shrink-0 text-accent" aria-hidden />
      <span className="min-w-0 flex-1">
        {summary.total === 1 ? '1 approval is' : `${formatNumber(summary.total)} approvals are`} waiting for your answer
        {parts.length > 1 ? ` — ${parts.join(' · ')}` : ''}.
      </span>
      <span className="shrink-0 font-medium text-accent">Open</span>
    </Link>
  );
}
